import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { BasicLayoutComponent } from './basicLayout.component';
import { BlankLayoutComponent } from './blankLayout.component';
import { TopNavigationLayoutComponent } from './topNavigationLayout.component';

import { NavigationComponent } from '../navigation/navigation.component';
import { FooterComponent } from '../footer/footer.component';
import { TopNavbarComponent } from '../topnavbar/topnavbar.component';
import { TopNavigationNavbarComponent } from '../topnavbar/topnavigationnavbar.component';
import { SpinnerModule } from 'app/components/common/spinner/spinner.module';
import { BreadcrumbsComponent } from 'app/components/common/layouts/breadCrumbs.component';
import { MatSelectModule } from '@angular/material/select';
import { FullscreenSpinnerComponent } from 'app/components/common/spinner/fullscreen-spinner.component';
// import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@ngneat/transloco';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NgxCaptureModule } from 'ngx-capture';

@NgModule({
  declarations: [
    FooterComponent,
    BasicLayoutComponent,
    BlankLayoutComponent,
    NavigationComponent,
    TopNavigationLayoutComponent,
    TopNavbarComponent,
    TopNavigationNavbarComponent,
    BreadcrumbsComponent,
  ],
  imports: [
    MatIconModule,
    BrowserModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    MatSelectModule,
    SpinnerModule,
    // MatTooltipModule,
    FormsModule,
    TranslocoModule,
    NgxCaptureModule
  ],
  exports: [
    FooterComponent,
    BasicLayoutComponent,
    BlankLayoutComponent,
    NavigationComponent,
    TopNavigationLayoutComponent,
    TopNavbarComponent,
    TopNavigationNavbarComponent,
    BreadcrumbsComponent,
  ],
})

export class LayoutsModule { }
